import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: import.meta.env["VITE_APP_API_KEY"],
  authDomain: import.meta.env["VITE_APP_AUTH_DOMAIN"],
  projectId: import.meta.env["VITE_APP_PROJECT_ID"],
  storageBucket: import.meta.env["VITE_APP_STORAGE_BUCKET"],
  messagingSenderId: import.meta.env["VITE_APP_SENDER_ID"],
  appId: import.meta.env["VITE_APP_APP_ID"],
  measurementId: import.meta.env["VITE_APP_ANALYTICS_ID"],
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// Can run with emulators on localhost if needed
/* if (window.location.hostname === 'localhost') {
  console.log('Running with emulators on localhost')
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
  connectFirestoreEmulator(db, 'localhost', 8080)
} */

export { auth, db };
